import { RecapCardRenderer } from '@/components/ui/recap/RecapCardRenderer';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import { formatDateDDMMYYYY } from '@/utils/dateUtils';

export default function ClientExportMatchRecapPage() {
  const [searchParams] = useSearchParams();

  const eventName = searchParams.get('eventName') ?? '';
  const rawDate = searchParams.get('eventDateFormatted') ?? '';
  const eventDateFormatted = formatDateDDMMYYYY(rawDate);
  const playerName = searchParams.get('playerName') ?? '';
  const playerAvatarUrl = searchParams.get('playerAvatarUrl') ?? '';
  const variant = searchParams.get('variant') ?? 'sorotan';

  const sportCategory = searchParams.get('sportCategory') ?? 'Futsal';
  const location = searchParams.get('location') ?? '';
  const bgImage = searchParams.get('bgImage') || undefined;

  const rawDeltaMMR = searchParams.get('deltaMMR');
  const deltaMMR = rawDeltaMMR !== null && rawDeltaMMR !== '' ? Number(rawDeltaMMR) : null;
  const rank = searchParams.has('rank') ? Number(searchParams.get('rank')) : 1;
  const totalPlayers = searchParams.has('totalPlayers') ? Number(searchParams.get('totalPlayers')) : undefined;

  let standings = undefined;
  const rawStandings = searchParams.get('standings');
  if (rawStandings) {
    try {
      standings = JSON.parse(rawStandings);
    } catch {
      standings = undefined;
    }
  }

  const rawStatKeys = searchParams.get('statKeys') || searchParams.get('stat_keys');
  const selectedStatKeys = rawStatKeys ? rawStatKeys.split(',') : undefined;

  const stats = {
    goals: Number(searchParams.get('goals') ?? 0),
    assists: Number(searchParams.get('assists') ?? 0),
    matches: Number(searchParams.get('matches') ?? 0),
    wins: searchParams.has('wins') ? Number(searchParams.get('wins')) : undefined,
    win_rate: searchParams.has('winRate') ? Number(searchParams.get('winRate')) : undefined,
    point: searchParams.has('point') ? Number(searchParams.get('point')) : undefined,
    point_loss: searchParams.has('pointLoss') ? Number(searchParams.get('pointLoss')) : undefined,
    is_racket: searchParams.get('isRacket') === 'true',
    rank,
    cleansheets: Number(
      searchParams.get('cleanSheet') ??
      searchParams.get('cleansheet') ??
      searchParams.get('cleansheets') ??
      searchParams.get('clean_sheet') ??
      0
    ),
    keyPasses: Number(searchParams.get('keyPasses') ?? 0),
    saves: Number(searchParams.get('saves') ?? 0),
    clearances: Number(searchParams.get('clearances') ?? 0),
    fouls: Number(searchParams.get('fouls') ?? 0),
    motm: Number(searchParams.get('motm') ?? 0),
    freestyle: Number(searchParams.get('freestyle') ?? 0),
    winstreak: Number(searchParams.get('winstreak') ?? 0),
    selectedStatKeys,
  };

  useEffect(() => {
    // Ensure document body, html, and root background are completely transparent for Playwright screenshot
    document.documentElement.style.backgroundColor = 'transparent';
    document.body.style.backgroundColor = 'transparent';

    return () => {
      document.documentElement.style.backgroundColor = '';
      document.body.style.backgroundColor = '';
    };
  }, []);

  return (
    <div
      className="w-screen h-screen flex items-center justify-center overflow-hidden bg-transparent"
      style={{ background: 'transparent', backgroundColor: 'transparent' }}
    >
      <RecapCardRenderer
        template={variant}
        eventName={eventName}
        eventDateFormatted={eventDateFormatted}
        playerName={playerName}
        playerAvatarUrl={playerAvatarUrl}
        rank={rank}
        stats={stats}
        standings={standings}
        totalPlayers={totalPlayers}
        sportCategory={sportCategory}
        location={location}
        deltaMMR={deltaMMR}
        bgImage={bgImage}
        transparent={true}
      />
    </div>
  );
}
